module.exports = __webpack_public_path__ + "static/media/calendar.2ed3cee0.svg";